<template>
  <b-nav-item class="back-link" data-test-id="BackLinkComponent" @click="onBackClick">
    <span class="text-red">Back</span>
  </b-nav-item>
</template>

<script>
export default {
  name: "BackLink",
  methods: {
    onBackClick() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.text-red {
  color: red;
}
.back-link a {
  padding: 0 !important;
}
</style>
